import { io } from "socket.io-client";
import { SERVER_URL } from "../abis/constants";

const socketOptions: any = {
    autoConnect: true,
    reconnectionDelayMax: 1000,
};

export const socket = io(SERVER_URL, socketOptions);